import gql from "graphql-tag";
import { useQuery } from "@apollo/react-hooks";
import { ApolloError } from "@apollo/client";
import { SeoQueryInput, SeoQueryResponse } from "src/types/graphql.d";

interface SeoContentResponse {
  getSeoContent: SeoQueryResponse | undefined;
}

interface SeoContentVars {
  page_url_slug: string;
  skipSeoContent?: boolean;
}
interface SeoContentHook {
  data: SeoContentResponse | undefined;
  loading: boolean;
  error: ApolloError | undefined;
}

const GET_SEO_CONTENT = gql`
  query getSeoContent($page_url_slug: String!) {
    getSeoContent(filter: { page_url_slug: $page_url_slug }) {
      meta_title
      meta_description
      meta_keywords
      canonical_tags
      robots_tag_value
      page_type
      brand
    }
  }
`;

const useSeoContent = ({
  page_url_slug,
  skipSeoContent,
}: SeoContentVars): SeoContentHook => {
  // Log the page_url_slug for debugging purposes
  const { data, loading, error } = useQuery<SeoContentResponse, SeoQueryInput>(
    GET_SEO_CONTENT,
    {
      variables: {
        page_url_slug,
      },
      fetchPolicy: "cache-first",
      skip: skipSeoContent || !page_url_slug,
    }
  );

  return {
    data,
    loading,
    error,
  };
};

export default useSeoContent;
